<template>
  <div>
      <UserProfileHeader
        :user="user"
        @profile-updated="profileUpdated"
        @follow-toggled="profileUpdated"
      />
      <section class="mb-2 mb-xl-3" v-show="user && user.description">
        <div class="container text-center">
          <div class="col-10 mx-auto">
            <p class="font-size-small">{{ user && user.description }}</p>
          </div>
        </div>
      </section>

      <!-- TABS -->
      <section>
        <div class="container">
          <b-tabs
            content-class="mt-4 mt-lg-5"
            nav-class="default-tabs font-size-lg-medium"
            v-model="tabIndex"
          >
            <!-- PUBLICATIONS TAB -->
            <b-tab title="Publicações" :active="user && !user.is_public_domain ? true : false">
              <div v-if="posts.length > 0">
                <div class="sortingSelect text-center text-md-right mt-n2 mt-lg-n4 mb-4">
                  <DropdownSelect
                    v-model.trim="sort"
                    @change="resetFilterPost"
                    :options="sortingOptions"
                    size="xSmall"
                  />
                </div>
                <PostThumbList
                  :posts="posts"
                />
                <div class="mt-3 text-center">
                  <Button
                    class="btn-outline-color2 btn-lg"
                    :loading="postsLoader"
                    @click="loadMorePosts"
                    v-if="isLoadMorePostsVisible"
                  >
                    Carregar mais
                  </Button>
                </div>
              </div>
              <div
                class="text-center"
                v-else-if="!postsLoader && hasLoadedPosts"
              >
                <p class="text-center">Não foi encontrado nenhum post</p>
                <router-link
                  :to="{ name: 'posts.create' }"
                  v-if="authUser && user && authUser.id === user.id"
                  class="btn btn-outline-color2 mt-2"
                >
                  Escrever agora
                </router-link>
              </div>
              <Loader
                color="color2"
                size="big"
                v-else
              />
            </b-tab> <!-- END PUBLICATIONS TAB -->
            <!-- BOOKS TAB -->
            <b-tab title="Livros" :active="user && user.is_public_domain ? true : false">
              <div v-if="books.length > 0">
                <div class="sortingSelect text-center text-md-right mt-n2 mt-lg-n4 mb-4">
                  <DropdownSelect
                    v-model.trim="sort"
                    @change="resetFilterBook"
                    :options="sortingOptions"
                    size="xSmall"
                  />
                </div>
                <BookThumbList
                  :books="books"
                />
                <div class="mt-3 text-center">
                  <Button
                    class="btn-outline-color2 btn-lg"
                    :loading="booksLoader"
                    @click="loadMoreBooks"
                    v-if="isLoadMoreBooksVisible"
                  >
                    Carregar mais
                  </Button>
                </div>
              </div>
              <div
                class="text-center"
                v-else-if="!booksLoader && hasLoadedBooks"
              >
                <p class="text-center">Não foi encontrado nenhum livro</p>
                <router-link
                  :to="{ name: 'books.create' }"
                  v-if="authUser && user && authUser.id === user.id"
                  class="btn btn-outline-color2 mt-2"
                >
                  Escrever agora
                </router-link>
              </div>
              <Loader
                color="color2"
                size="big"
                v-else
              />
            </b-tab> <!-- END BOOKS TAB -->
            <!-- CHAPTERS TAB -->
            <b-tab title="Capítulos">
              <div v-if="chapters.length > 0">
                <div class="sortingSelect text-center text-md-right mt-n2 mt-lg-n4 mb-4">
                  <DropdownSelect
                    v-model.trim="sort"
                    @change="resetFilterChapter"
                    :options="sortingOptions"
                    size="xSmall"
                  />
                </div>
                <PostThumbList
                  :posts="chapters"
                />
                <div class="mt-3 text-center">
                  <Button
                    class="btn-outline-color2 btn-lg"
                    :loading="chaptersLoader"
                    @click="loadMoreChapters"
                    v-if="isLoadMoreChaptersVisible"
                  >
                    Carregar mais
                  </Button>
                </div>
              </div>
              <div
                class="text-center"
                v-else-if="!chaptersLoader && hasLoadedChapters"
              >
                <p class="text-center">Não foi encontrado nenhum capítulo</p>
              </div>
              <Loader
                color="color2"
                size="big"
                v-else
              />
            </b-tab> <!-- END CHAPTERS TAB -->
            <!-- CATEGORIES TAB -->
            <b-tab title="Categorias">
              <div v-if="categories.length > 0">
                <div class="common-card-listing listing-rowed items-3-per-row mt-4 mt-lg-5">
                  <ul class="list-wrap">
                    <li class="list-item"
                      v-if="authUser && user && authUser.id === user.id"
                    >
                      <router-link
                        :to="{ name: 'categories.create' }"
                        class="create-card-link"
                      >
                        <span class="create-card">
                          <span class="content font-weight-bold text-center">
                            <span class="d-block font-size-large">
                              <i class="fa fa-plus-circle"></i>
                            </span>
                            Criar Categoria
                          </span>
                        </span>
                      </router-link>
                    </li>
                    <li
                      class="list-item"
                      v-for="category in categories"
                      :key="category.id"
                    >
                      <CategoryCard
                        :category="category"
                      />
                    </li>
                  </ul>
                  <div class="mt-3 text-center">
                  <Button
                    class="btn-outline-color2 btn-lg"
                    :loading="categoriesLoader"
                    @click="loadMoreCategories"
                    v-if="isLoadMoreCategoriesVisible"
                  >
                    Carregar mais
                  </Button>
                </div>
                </div>
              </div>
              <div
                class="text-center"
                v-else-if="!categoriesLoader && hasLoadedCategories"
              >
                <p>Não foi encontrada nenhuma categoria</p>
                <router-link
                  :to="{ name: 'categories.create' }"
                  v-if="authUser && user && authUser.id === user.id"
                  class="btn btn-outline-color2 mt-2"
                >
                  Criar categoria
                </router-link>
              </div>
              <Loader
                color="color2"
                size="big"
                v-else
              />
            </b-tab> <!-- END CATEGORIES TAB -->
            <!-- GROUPS TAB -->
            <b-tab title="Comunidades">
              <div v-if="groups.length > 0">
                <div class="common-card-listing listing-rowed items-2-per-row mt-4 mt-lg-5">
                  <ul class="list-wrap">
                    <li
                      class="list-item"
                      v-for="group in groups"
                      :key="group.id"
                    >
                      <GroupCard
                        :group="group"
                      />
                    </li>
                  </ul>
                  <div class="mt-3 text-center">
                    <Button
                      class="btn-outline-color2 btn-lg"
                      :loading="groupsLoader"
                      @click="loadMoreGroups"
                      v-if="isLoadMoreGroupsVisible"
                    >
                      Carregar mais
                    </Button>
                  </div>
                </div>
              </div>
              <div
                class="text-center"
                v-else-if="!groupsLoader && hasLoadedGroups"
              >
                <p>Não foi encontrada nenhuma comunidade</p>
                <router-link
                  :to="{ name: 'groups.create' }"
                  v-if="authUser && user && authUser.id === user.id"
                  class="btn btn-outline-color2 mt-2"
                >
                  Criar comunidade
                </router-link>
              </div>
              <Loader
                color="color2"
                size="big"
                v-else
              />
            </b-tab> <!-- END GROUPS TAB -->
          </b-tabs>
        </div>
      </section>
  </div>
</template>

<script>

import BooksService from '@/modules/books/services/books-service'
import CategoriesService from '@/modules/categories/services/categories-service'
import GroupsService from '@/modules/groups/services/groups-service'
import UsersService from '@/modules/users/services/users-service'
import variables from '@/mixins/variables'
import seo from '@/mixins/seo'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button.vue'
import BookThumbList from '@/components/books/BookThumbList'
import CategoryCard from '@/components/categories/CategoryCard.vue'
import GroupCard from '@/components/groups/GroupCard'
import Loader from '@/components/common/Loader/Loader.vue'
import PostThumbList from '@/components/post/PostThumbList.vue'
import UserProfileHeader from '@/components/user/UserProfileHeader.vue'
import DropdownSelect from '@/components/common/Select/DropdownSelect'

export default {
  mixins: [variables, seo],
  components: {
    Button,
    BookThumbList,
    CategoryCard,
    GroupCard,
    Loader,
    PostThumbList,
    UserProfileHeader,
    DropdownSelect
  },
  data () {
    return {
      user: null,
      posts: [],
      categories: [],
      groups: [],
      books: [],
      chapters: [],
      postsPage: 1,
      categoriesPage: 1,
      groupsPage: 1,
      booksPage: 1,
      chaptersPage: 1,
      postsLoader: false,
      hasLoadedPosts: false,
      categoriesLoader: false,
      hasLoadedCategories: false,
      booksLoader: false,
      hasLoadedBooks: false,
      chaptersLoader: false,
      hasLoadedChapters: false,
      groupsLoader: false,
      hasLoadedGroups: false,
      isLoadMoreCategoriesVisible: true,
      isLoadMorePostsVisible: true,
      isLoadMoreBooksVisible: true,
      isLoadMoreChaptersVisible: true,
      sort: 'DESC',
      sortingOptions: [
        {
          key: 'ASC',
          value: 'Mais antigos primeiro'
        },
        {
          key: 'DESC',
          value: 'Mais recentes primeiro'
        },
        {
          key: 'views',
          value: 'Mais lidos'
        }
      ],
      isLoadMoreGroupsVisible: true,
      tabIndex: 0
    }
  },
  computed: {
    ...mapState('auth', {
      authenticated: state => state.authenticated
    }),
    ...mapState('users', {
      authUser: state => state.user
    }),
    currentUser () {
      return this.$route.params.username
    }
  },
  metaInfo () {
    return {
      title: this.user ? this.user.name : '',
      meta: [
        { vmid: 'description', name: 'description', content: this.user && this.user.description ? this.user.description : this.seoDefaultDescription },
        { vmid: 'og-description', name: 'og:description', content: this.user && this.user.description ? this.user.description : this.seoDefaultDescription },
        { vmid: 'og-title', name: 'og:title', content: this.user ? `${this.user.name} | ${this.seoDefaultTitleAppend}` : `${this.seoDefaultTitle} | ${this.seoDefaultTitleAppend}` },
        { vmid: 'og-image', name: 'og:image', content: this.user && this.user.has_cover ? this.user.cover : this.seoDefaultImage }
      ]
    }
  },
  created () {
    this.getUser()
  },
  watch: {
    currentUser (newVal, oldVal) {
      this.reset()
      this.getUser()
    }
  },
  methods: {
    async getUser (getAll = true) {
      try {
        const user = await UsersService.getUser(this.$route.params.username)
        this.user = user
        if (getAll) {
          this.getPosts()
          this.getCategories()
          this.getBooks()
          this.getChapters()
          this.getGroups()
        }
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    async getPosts () {
      this.postsLoader = true
      try {
        // Get order by and sort
        const orderBy = this.sort === 'views' ? 'views' : null
        const sort = this.sort === 'views' ? 'DESC' : this.sort

        const params = {
          userId: this.user.id,
          page: this.postsPage,
          sort: sort,
          orderBy: orderBy,
          postType: 'post'
        }

        const posts = await UsersService.getPosts(params)
        this.posts = [...this.posts, ...posts]
        if (posts <= 0) this.isLoadMorePostsVisible = false
        // On first load, set tab index if has more posts than books
        if (this.postsPage === 1) {
          if (this.posts.length > this.books.length) this.tabIndex = 0
          else this.tabIndex = 1
        }
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.hasLoadedPosts = true
      this.postsLoader = false
    },
    async getChapters () {
      this.chaptersLoader = true
      try {
        // Get order by and sort
        const orderBy = this.sort === 'views' ? 'views' : null
        const sort = this.sort === 'views' ? 'DESC' : this.sort

        const params = {
          userId: this.user.id,
          page: this.chaptersPage,
          sort: sort,
          orderBy: orderBy,
          postType: 'chapter'
        }
        const chapters = await UsersService.getPosts(params)
        this.chapters = [...this.chapters, ...chapters]
        if (chapters <= 0) this.isLoadMoreChaptersVisible = false
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.hasLoadedChapters = true
      this.chaptersLoader = false
    },
    async getBooks () {
      this.booksLoader = true
      try {
        // Get order by and sort
        const orderBy = this.sort === 'views' ? 'views' : null
        const sort = this.sort === 'views' ? 'DESC' : this.sort

        const params = {
          userId: this.user.id,
          page: this.booksPage,
          sort: sort,
          orderBy: orderBy
        }

        const books = await BooksService.getBooks(params)
        this.books = [...this.books, ...books]
        if (books <= 0) this.isLoadMoreBooksVisible = false
        // On first load, set tab index if has more books than posts
        if (this.booksPage === 1) {
          if (this.books.length > this.posts.length) this.tabIndex = 1
          else this.tabIndex = 0
        }
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.hasLoadedBooks = true
      this.booksLoader = false
    },
    async getCategories () {
      this.categoriesLoader = true
      try {
        const categories = await CategoriesService.getCategories({ userId: this.user.id, page: this.categoriesPage })
        this.categories = [...this.categories, ...categories]
        if (categories.length <= 0) this.isLoadMoreCategoriesVisible = false
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.hasLoadedCategories = true
      this.categoriesLoader = false
    },
    async getGroups () {
      this.groupsLoader = true
      try {
        const groups = await GroupsService.getGroups({ userId: this.user.id, page: this.groupsPage })
        this.groups = [...this.groups, ...groups]
        if (groups.length <= 0) this.isLoadMoreGroupsVisible = false
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.hasLoadedGroups = true
      this.groupsLoader = false
    },
    async loadMorePosts () {
      this.postsPage++
      this.getPosts()
    },
    async loadMoreCategories () {
      this.categoriesPage++
      this.getCategories()
    },
    async loadMoreBooks () {
      this.booksPage++
      this.getBooks()
    },
    async loadMoreChapters () {
      this.chaptersPage++
      this.getChapters()
    },
    async loadMoreGroups () {
      this.groupsPage++
      this.getGroups()
    },
    profileUpdated () {
      this.getUser(false)
    },
    reset () {
      this.user = null
      this.posts = []
      this.categories = []
      this.groups = []
      this.books = []
      this.chapters = []
      this.postsPage = 1
      this.categoriesPage = 1
      this.groupsPage = 1
      this.booksPage = 1
      this.chaptersPage = 1
      this.postsLoader = false
      this.categoriesLoader = false
      this.booksLoader = false
      this.groupsLoader = false
      this.chaptersLoader = false
      this.isLoadMoreCategoriesVisible = true
      this.isLoadMorePostsVisible = true
      this.isLoadMoreBooksVisible = true
      this.isLoadMoreChaptersVisible = true
    },
    resetFilterPost () {
      this.postsPage = 1
      this.postsLoader = false
      this.isLoadMorePostsVisible = true
      this.posts = []
      this.getPosts()
    },
    resetFilterBook () {
      this.booksPage = 1
      this.booksLoader = false
      this.isLoadMoreBooksVisible = true
      this.books = []
      this.getBooks()
    },
    resetFilterChapter () {
      this.chaptersPage = 1
      this.chaptersLoader = false
      this.isLoadMoreChaptersVisible = true
      this.chapters = []
      this.getChapters()
    }
  }
}
</script>
